<template>
  <div class="flex flex-row pt-0.5 text-left">
    <inline-svg
      :src="require('@/assets/images/base/icons/warning_circle.svg')"
      class="h-4 w-4 text-error"
    />
    <span class="error-message ml-0.5 text-xs font-light text-error">
      <slot />
    </span>
  </div>
</template>

<script>
import InlineSvg from "vue-inline-svg";

export default {
  name: "CoreErrorMessage",
  components: { InlineSvg },
};
</script>
